export const UserIcon = ({ className }: Readonly<{ className?: string }>) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00131 7.99993C9.84226 7.99993 11.3346 6.50754 11.3346 4.66659C11.3346 2.82564 9.84226 1.33325 8.00131 1.33325C6.16036 1.33325 4.66797 2.82564 4.66797 4.66659C4.66797 6.50754 6.16036 7.99993 8.00131 7.99993Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7268 14.6667C13.7268 12.0867 11.1601 10 8.00011 10C4.84011 10 2.27344 12.0867 2.27344 14.6667"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
